module.exports = __webpack_public_path__ + "static/media/mainfarm-loader.ddb3d957.svg";